import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { ProductBlock } from '../components/ProductBlock.js';
import { useListingProductData } from '../hooks/use-listing-product-data.js';

const SimpleProductBlock = ({ product , onClick , onImpression , className , tabIndex , reimbursableLogos ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref  } = useWasSeenByUser();
    const handleVariantChange = React.useCallback((sku)=>{
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) onImpression();
    }, [
        wasSeen
    ]);
    const { variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useListingProductData(product, activeSku);
    if (!variantInfo || !variantUrl) {
        console.error('CommerceToolsProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        productType: product.productType,
        activeSku: activeSku,
        reimbursableLogos: reimbursableLogos,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        isInsuranceReimbursable: isInsuranceReimbursable,
        tabIndex: tabIndex
    }, variantInfo));
};

export { SimpleProductBlock, SimpleProductBlock as default };
//# sourceMappingURL=SimpleProductBlock.js.map
